<template>
	<div class="mall-goods-detail">
		<!-- 面包屑导航 -->
		<div class="breadcrumb-wrap">
			<el-breadcrumb separator=">">
				<el-breadcrumb-item :to="{ path: '/mall/index' }">应用商城</el-breadcrumb-item>
				<el-breadcrumb-item>商品详情</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 上方：商品信息 -->
		<div class="goods-info-section">
			<!-- 左侧：图片轮播 -->
			<div class="goods-gallery">
				<div class="main-image">
					<img :src="mainImage" :alt="goodsInfo.title" />
				</div>
				<div class="thumb-list">
					<div
						v-for="(img, index) in goodsInfo.images"
						:key="index"
						class="thumb-item"
						:class="{ active: activeImageIndex === index }"
						@click="handleSwitchImage(index)"
					>
						<img :src="img" />
					</div>
				</div>
			</div>

			<!-- 右侧：商品信息 -->
			<div class="goods-meta">
				<h1 class="goods-title">{{ goodsInfo.title }}</h1>
				<div class="goods-tags">
					<el-tag v-for="(tag, index) in goodsInfo.tags" :key="index" size="small" type="success" class="meta-tag">{{ tag }}</el-tag>
				</div>

				<div class="meta-list">
					<div class="meta-item">
						<span class="meta-label">商品价格：</span>
						<span class="meta-value price-value">{{ goodsInfo.price }}</span>
					</div>
					<div class="meta-item">
						<span class="meta-label">所属类目：</span>
						<el-tag v-for="(cat, index) in goodsInfo.categories" :key="index" size="small" type="primary" class="meta-tag">{{ cat }}</el-tag>
					</div>
					<div class="meta-item">
						<span class="meta-label">交付周期：</span>
						<span class="meta-value highlight-text">协商约定，按需求评估</span>
					</div>
					<div class="meta-item">
						<span class="meta-label">交付约定：</span>
						<span class="meta-value">分阶段交付，验收通过后付款</span>
					</div>
					<div class="meta-item">
						<span class="meta-label">服务方式：</span>
						<span class="meta-value">远程协作 / 驻场开发（可选）</span>
					</div>
				</div>

				<!-- 联系我们 -->
				<div class="contact-box">
					<div class="contact-left">
						<i class="el-icon-phone-outline contact-icon"></i>
						<div class="contact-info">
							<div class="contact-label">联系我们</div>
							<div class="contact-phone">{{ goodsInfo.contactPhone || 'xxx（请填写联系方式）' }}</div>
						</div>
					</div>
					<el-button type="text" class="copy-btn" @click="handleCopyPhone">
						<i class="el-icon-document-copy"></i>
						复制信息
					</el-button>
				</div>

				<!-- 操作按钮 -->
				<div class="action-btns">
					<el-button type="primary" size="medium" class="consult-btn" @click="handleConsult">立即咨询</el-button>
					<el-button type="warning" size="medium" class="cart-btn" @click="handleAddCart">
						<i class="el-icon-shopping-cart-2"></i>
						加入购物车
					</el-button>
				</div>
			</div>
		</div>

		<!-- 下方：服务详情 -->
		<div class="service-detail-section">
			<div class="section-header">
				<div class="section-tab active">服务详情</div>
			</div>
			<div class="detail-content" v-html="goodsInfo.detailContent"></div>
		</div>
	</div>
</template>

<script>
	/**
	 * @description 商城商品详情页
	 */
	export default {
		name: 'MallGoodsDetail',
		data() {
			return {
				activeImageIndex: 0,
				goodsInfo: {
					title: '定制化软件开发服务',
					images: [
						require('@/assets/mall/goods/goods-demo.png'),
						require('@/assets/mall/goods/goods-demo.png'),
						require('@/assets/mall/goods/goods-demo.png'),
						require('@/assets/mall/goods/goods-demo.png'),
						require('@/assets/mall/goods/goods-demo.png')
					],
					tags: ['专业团队', '按需定制', '全程跟进'],
					categories: ['技术服务', '软件开发', '定制开发'],
					price: '面议',
					contactPhone: '1859234781',
					detailContent: `
						<h3>服务介绍</h3>
						<p>我们提供全链路定制化软件开发服务，涵盖需求分析、UI/UX设计、系统开发、测试部署及后期维护。拥有丰富的政府项目及企业信息化系统建设经验，可根据您的实际业务场景量身打造最合适的解决方案。</p>
						<h3>服务范围</h3>
						<ul>
							<li>Web系统开发 — 企业官网、管理后台、数据可视化平台</li>
							<li>移动端开发 — 微信小程序、App（iOS/Android）</li>
							<li>云服务集成 — 腾讯云/阿里云部署、API对接、数据迁移</li>
							<li>数据平台建设 — 数据中台、报表系统、大屏可视化</li>
						</ul>
						<h3>服务流程</h3>
						<p>1. 需求沟通 → 2. 方案设计 → 3. 开发实施 → 4. 测试验收 → 5. 交付上线</p>
					`
				}
			}
		},
		computed: {
			mainImage() {
				return this.goodsInfo.images[this.activeImageIndex] || this.goodsInfo.images[0]
			}
		},
		methods: {
			// 切换主图
			handleSwitchImage(index) {
				this.activeImageIndex = index
			},
			// 复制联系方式
			handleCopyPhone() {
				const phone = this.goodsInfo.contactPhone || ''
				if (!phone) {
					this.$message.warning('暂无联系方式')
					return
				}
				if (navigator.clipboard) {
					navigator.clipboard.writeText(phone).then(() => {
						this.$message.success('复制成功')
					}).catch(() => {
						this.$message.error('复制失败')
					})
				} else {
					// 降级方案
					const input = document.createElement('input')
					input.value = phone
					document.body.appendChild(input)
					input.select()
					document.execCommand('copy')
					document.body.removeChild(input)
					this.$message.success('复制成功')
				}
			},
			// 立即咨询
			handleConsult() {
				this.$message.info('咨询功能开发中')
			},
			// 加入购物车
			handleAddCart() {
				this.$message.success('已加入购物车')
			}
		}
	}
</script>

<style lang="scss" scoped>
	.mall-goods-detail {
		width: $main-page-width;
		margin: 0 auto;
		padding: 20px 0 40px;

		.breadcrumb-wrap {
			margin-bottom: 20px;
		}

		// 上方商品信息
		.goods-info-section {
			display: flex;
			gap: 30px;
			background: #fff;
			padding: 30px;
			border-radius: 8px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
			margin-bottom: 20px;
		}

		// 左侧图片轮播
		.goods-gallery {
			width: 400px;
			flex-shrink: 0;

			.main-image {
				width: 100%;
				height: 400px;
				border-radius: 8px;
				overflow: hidden;
				background: #f5f5f5;
				display: flex;
				align-items: center;
				justify-content: center;
				margin-bottom: 12px;

				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}

			.thumb-list {
				display: flex;
				gap: 10px;

				.thumb-item {
					width: 70px;
					height: 70px;
					border-radius: 4px;
					overflow: hidden;
					cursor: pointer;
					border: 2px solid transparent;
					transition: all 0.3s;
					background: #f5f5f5;
					display: flex;
					align-items: center;
					justify-content: center;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					&:hover {
						border-color: #409eff;
					}

					&.active {
						border-color: #409eff;
						box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
					}
				}
			}
		}

		// 右侧商品信息
		.goods-meta {
			flex: 1;

			.goods-title {
				font-size: 22px;
				font-weight: bold;
				color: #333;
				margin: 0 0 12px 0;
				line-height: 1.4;
			}

			.goods-tags {
				margin-bottom: 20px;

				.meta-tag {
					margin-right: 8px;
				}
			}

			.meta-list {
				margin-bottom: 20px;

				.meta-item {
					display: flex;
					align-items: center;
					margin-bottom: 12px;
					font-size: 14px;

					.meta-label {
						color: #666;
						width: 80px;
						flex-shrink: 0;
					}

					.meta-value {
						color: #333;
					}

					.price-value {
						font-size: 24px;
						font-weight: bold;
						color: #e6a23c;
					}

					.highlight-text {
						color: #409eff;
						font-weight: 500;
					}
				}
			}

			// 联系我们
			.contact-box {
				display: flex;
				align-items: center;
				justify-content: space-between;
				background: #f0f9eb;
				border-radius: 8px;
				padding: 15px 20px;
				margin-bottom: 24px;

				.contact-left {
					display: flex;
					align-items: center;
					gap: 12px;
				}

				.contact-icon {
					font-size: 28px;
					color: #67c23a;
				}

				.contact-info {
					.contact-label {
						font-size: 12px;
						color: #666;
						margin-bottom: 4px;
					}

					.contact-phone {
						font-size: 16px;
						font-weight: bold;
						color: #333;
					}
				}

				.copy-btn {
					color: #67c23a;
					font-size: 14px;

					&:hover {
						color: #85ce61;
					}
				}
			}

			// 操作按钮
			.action-btns {
				display: flex;
				gap: 16px;

				.consult-btn {
					min-width: 140px;
					font-size: 16px;
				}

				.cart-btn {
					min-width: 140px;
					font-size: 16px;
					background: #e6a23c;
					border-color: #e6a23c;
					color: #fff;

					&:hover {
						background: #ebb563;
						border-color: #ebb563;
					}
				}
			}
		}

		// 下方服务详情
		.service-detail-section {
			background: #fff;
			border-radius: 8px;
			box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
			overflow: hidden;

			.section-header {
				display: flex;
				border-bottom: 1px solid #ebeef5;

				.section-tab {
					padding: 14px 30px;
					font-size: 16px;
					color: #666;
					cursor: pointer;
					position: relative;
					transition: color 0.3s;

					&:hover {
						color: #409eff;
					}

					&.active {
						color: #409eff;
						font-weight: bold;

						&::after {
							content: '';
							position: absolute;
							bottom: 0;
							left: 20px;
							right: 20px;
							height: 2px;
							background: #409eff;
						}
					}
				}
			}

			.detail-content {
				padding: 30px;
				font-size: 14px;
				line-height: 1.8;
				color: #333;

				::v-deep {
					h3 {
						font-size: 16px;
						font-weight: bold;
						color: #333;
						margin: 24px 0 12px 0;
						padding-left: 12px;
						border-left: 4px solid #409eff;
					}

					p {
						margin: 0 0 12px 0;
						color: #666;
					}

					ul {
						margin: 0 0 12px 0;
						padding-left: 20px;
						list-style: disc;

						li {
							margin-bottom: 8px;
							color: #666;
						}
					}
				}
			}
		}
	}
</style>
